import React, { useState } from 'react'
import { Routes, Route, useLocation } from "react-router-dom";

import TopNav from '../../TopNav';
import SendMoney1 from './SendMoney1';
import Step1SendMoney from './Step1SendMoney';
import Step2SendMoney from './Step2SendMoney';
import Step3SendMoney from './Step3SendMoney';
import SendMoneySuccess from './SendMoneySuccess';
import './sendMoney.css';

const SendMoney = ({ toggleSidebar, handleCloseSidebar, userDetails}) => {
  return (
    <>
      <TopNav title='Send Money' userDetails={userDetails} toggleSidebar={toggleSidebar} />
      <section className="main p-2 cards__page">
        <div className="container-fluid p-0">
          
          {/* <TopNav title={getTitle()} userDetails={userDetails} toggleSidebar={toggleSidebar} /> */}
          
          <section className="wrapper__content" onClick={handleCloseSidebar}>
            <Routes>
              <Route index element={<SendMoney1 userDetails={userDetails} /> } />
              <Route path="step1" element={<Step1SendMoney userDetails={userDetails} />} />
              <Route path="step2" element={<Step2SendMoney userDetails={userDetails} />} />
              <Route path="step3" element={<Step3SendMoney userDetails={userDetails} />} />
              <Route path="pending" element={<SendMoneySuccess userDetails={userDetails} />} />
              <Route path="success" element={<SendMoneySuccess userDetails={userDetails} />} />
            </Routes>
          </section>
          
        </div>
      </section>
    </>
  )
}

export default SendMoney;